import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div>
            
<main className="bg-white relative overflow-hidden h-screen relative">
  
    <div className="container w-5/6  mx-auto h-screen pt-32 md:pt-0 px-6 z-10 flex items-center justify-between">
        <div className="container mx-auto px-6 flex flex-col-reverse lg:flex-row justify-between items-center relative">
            <div className="w-full  mb-16 md:mb-8 text-center lg:text-left">
                <h1 className="font-light  font-sans text-center lg:text-left text-5xl lg:text-8xl mt-12 md:mt-0 text-gray-700">
                    404 <br />
                    Sorry, this page isn&#x27;t available
                </h1>

                <Link to="/home" className="px-3 py-2 transition ease-in duration-200 uppercase hover:text-gray-700 text-gray-400 focus:outline-none">
                        
                   
                <button className="px-2 py-2 w-36 mt-16 font-light transition ease-in duration-200 hover:bg-gray-500 text-white border-2 text-lg border-gray-600 bg-gray-500 hover:bg-gray-700 focus:outline-none">
                    Go back home
                </button>
                </Link>
            </div>
       
        </div>
    </div>
</main>

        </div>
    );
};

export default NotFound;